import styled from "styled-components";

export const FreeSessionsNote = styled.p`
	font-weight: 500;
	margin-bottom: 1em;
`;
